module.exports = __webpack_public_path__ + "media/images/logos/ncce-logo-3089329bd9bf54e6019e9cceba011a88.png";